import { Component, EventEmitter, Input, OnInit, Output, OnChanges } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CustomFilter, Filter, FilterConfigOption, FilterSelected, FilterTag } from '@scalefast/core';
import { FilterGroupBy } from 'src/app/shared/pipes/filter-groupby.pipe';
import { FilterNotificationService } from 'src/app/shared/services/filter-notification.service';
import { AppFilterTagsComponent } from '../filter-tags/filter-tags.component';
import { AppMultiSelectComponent } from '../multi-select/multi-select.component';
import { AppSelectDropdownComponent } from '../select-dropdown/select-dropdown.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-filter-template',
  templateUrl: './filter-template.component.html',
  standalone: true,
  styleUrls: ['./filter-template.component.scss'],
  imports: [
    NgClass,
    ReactiveFormsModule,
    AppMultiSelectComponent,
    AppSelectDropdownComponent,
    AppFilterTagsComponent,
    FilterGroupBy,
  ],
})
export class AppFilterTemplateComponent implements OnInit, OnChanges {
  @Input() filters: Array<CustomFilter> | undefined;
  @Input() tagsArray: Array<FilterTag> | undefined;
  @Output() filterEvent = new EventEmitter();
  @Output() removeFilterTagEvent = new EventEmitter<Filter>();
  @Output() createFilterTagEvent = new EventEmitter();
  @Output() removeAllTagsEvent = new EventEmitter();

  tagsValues: string[] = [];

  private stashOptions: any = {};
  private scheme?: string[] = undefined;

  @Input() filterCriteria: string = 'all';
  @Input() aggregations: any;

  constructor(filterNotificationService: FilterNotificationService) {
    filterNotificationService.resetTriggered$.subscribe((res) => {
      this.emptyStash();
    });
  }

  ngOnInit() {
    if (this.filters) {
      if (Object.keys(this.filters).length > 0) {
        this.tagsArray = this.transformLoadCriterialToFilter(this.filters);
      } else {
        this.filters = [];
      }
    }
  }

  getCheckedList(event: Array<FilterSelected>, filter: CustomFilter) {
    const { value, groupBy } = filter;
    const emitObject: Filter = {
      name: value,
      values: event.map((item: FilterSelected) => item.value),
      groupBy: groupBy,
    };

    this.createFiltersTag(event, filter);
    this.filterEvent.emit(emitObject);
  }

  createFiltersTag(event: Array<FilterSelected>, filter: CustomFilter) {
    this.createFilterTagEvent.emit({ tagList: event, filter: filter });
  }

  removeTagEvent(filterTag: FilterTag) {
    const emitObject: Filter = {
      name: filterTag.name,
      values: filterTag.values.map((item: FilterSelected) => item.value),
      groupBy: filterTag.groupBy,
    };
    this.removeFilterTagEvent.emit(emitObject);
  }

  transformLoadCriterialToFilter(filters: Array<CustomFilter>): FilterTag[] {
    return filters
      .map(({ value, options, groupBy }: CustomFilter) => ({
        name: value,
        values: options
          .filter((option: FilterConfigOption) => {
            return option.checked ? option.value : '';
          })
          .map((item: FilterConfigOption) => {
            return { label: item.label, value: item.value };
          }),
        groupBy,
      }))
      .filter((item: FilterTag) => item.values.length > 0);
  }

  removeAllTags() {
    this.removeAllTagsEvent.emit();
  }

  ngOnChanges(): void {
    if (this.aggregations) {
      this.processAggregations(this.aggregations);
    }
  }

  private processAggregations(d: any) {
    this.recoverStashedItems(d);

    if (this.filters) {
      this.filters.map((element) => {
        if (element.value === 'sort') {
          return element;
        }

        const elementFound: any = Array.from(d).find((aggregate: any) => Object.keys(aggregate)[0] === element.value);

        if (elementFound) {
          const aggregateValues = Object.keys(elementFound[Object.keys(elementFound)[0]]);

          element.options = element.options.filter((option, index) => {
            if (aggregateValues.includes(option.value) || option.value.includes('separator')) {
              return true;
            }
            this.stashOptions[element.value].push({ position: index + 1, item: option });
            return false;
          });
        }

        return element;
      });
    }

    this.deleteEmptySeparators();
    this.restoreSortOrder();
  }

  private restoreSortOrder() {
    for (const key in this.stashOptions) {
      this.stashOptions[key].sort((a: any, b: any) => {
        return a.position - b.position;
      });
    }
  }

  private recoverStashedItems(aggregations: any) {
    if (this.filters && this.stashOptions) {
      for (const key in this.stashOptions) {
        const recoverfilter = this.filters?.find((filter) => filter.value == key);
        if (recoverfilter) {
          this.stashOptions[key].forEach((option: any) => {
            recoverfilter.options.splice(option.position - 1, 0, option.item);
          });
        }
      }

      this.emptyStash(aggregations);
    }
  }

  private deleteEmptySeparators() {
    if (this.filters) {
      this.filters.map((element) => {
        if (element.value === 'sort') {
          return element;
        }

        const options = element.options;
        for (let i = 0; i < options.length; i++) {
          if (
            (options[i].value.includes('separator') && !options[i + 1]) ||
            (options[i].value.includes('separator') && options[i + 1].value.includes('separator'))
          ) {
            const position = /separator_(.*)/.exec(options[i].value);
            if (position && position[1]) {
              this.stashOptions[element.value].push({
                position: parseInt(position[1]),
                item: options[i],
              });
              element.options.splice(i, 1);
              i--;
            }
          }
        }

        return element;
      });
    }
  }

  private emptyStash(aggregations?: any): void {
    this.stashOptions = {};

    if (!this.scheme && aggregations) {
      this.scheme = [];
      aggregations.forEach((element: any) => {
        this.scheme?.push(Object.keys(element)[0]);
      });
    }

    this.scheme?.forEach((element: any) => {
      this.stashOptions[element] = [];
    });
  }
}
export { CustomFilter };
